export default function ReferOtherIcon() {
  return (
    <svg
      width="37"
      height="36"
      viewBox="10.639 10.001 35.94 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_10402_5171)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6387 18.4012C10.6387 13.4933 14.1256 10.001 19.0251 10.001H38.1924C43.0923 10.001 46.5788 13.4937 46.5788 18.4012V38.2002C46.5788 42.5082 43.0919 46.0005 38.7914 46.0005H18.4261C14.1252 46.0005 10.6387 42.5078 10.6387 38.2002V18.4012Z"
          fill="url(#paint0_linear_10402_5171)"
        />
      </g>
      <ellipse
        cx="20.8179"
        cy="28.0001"
        rx="2.39601"
        ry="2.39997"
        fill="#8065C9"
      />
      <ellipse
        cx="28.605"
        cy="28.0001"
        rx="2.39601"
        ry="2.39997"
        fill="#8065C9"
      />
      <ellipse
        cx="36.3882"
        cy="28.0001"
        rx="2.39601"
        ry="2.39997"
        fill="#8065C9"
      />
      <defs>
        <filter
          id="filter0_d_10402_5171"
          x="0.638672"
          y="0.000976562"
          width="55.9395"
          height="55.9995"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10402_5171"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10402_5171"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10402_5171"
          x1="10.6387"
          y1="10.001"
          x2="10.6387"
          y2="46.0005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#E8E8E8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
